import { getSiteConfig } from '@shared/config';

function isNonCacheableRoute(pathname: string) {
  const { NON_CACHEABLE_ROUTES_REGEX } = getSiteConfig();

  return NON_CACHEABLE_ROUTES_REGEX.some((regex: string) => new RegExp(regex).test(pathname));
}

export default isNonCacheableRoute;
